import * as _4 from 'lodash4';
export class OpenModalFlag {
  private isModalOpenFlag: boolean;

  setFlag(isOpen: boolean) {
    this.isModalOpenFlag = isOpen;
  }

  isModalOpen() {
    return this.isModalOpenFlag;
  }
}

angular.module('capability-ng-scheduler').service('ngOpenModalFlag', OpenModalFlag);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/components/calendar_placeholder_alert/openModalFlag.ts